import { ResolverTag, Site } from '@ps/web-core-enums';
import React from 'react';
import { useSelector } from 'react-redux';

import Link from '@swf/components/Link/Link';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import Translation from '@swf/components/Translation/Translation';
import useResolver from '@swf/core/hooks/useResolver';
import { select } from '@swf/core/store';

import Alert from '../../../../../Alert/Alert';

import {
  TXTCLI_Gambling_is_supposed_to_be_fun_ELL,
  TXTWCL_Just_so_you_knowX_youXre_about_ELL,
  TXTWCL_Read_more_about_play_money_and_ELL,
  TXTWCL_WeXll_need_a_few_more_details__ELL
} from './InfoBox.messages.json';
import { info } from './InfoBox.scss';

interface Props {
  onEulaLinkClick?(): void;
}

const InfoBox: React.FC<Props> = ({ onEulaLinkClick }) => {
  const siteId = useSelector(select.cms.getSiteId);
  const MCEula = useResolver(ResolverTag.MCEula);

  switch (siteId) {
    case Site.CAON:
      return (
        <Alert variant="info" className={info}>
          <Translation
            {...TXTCLI_Gambling_is_supposed_to_be_fun_ELL}
            values={{
              a: (msg: string) => (
                <ResolverLink resolverTag={ResolverTag.ConnexOntario}>{msg}</ResolverLink>
              )
            }}
          />
        </Alert>
      );
    case Site.PT:
      return (
        <Alert variant="info" className={info}>
          <Translation {...TXTWCL_Just_so_you_knowX_youXre_about_ELL} />{' '}
          <Translation {...TXTWCL_WeXll_need_a_few_more_details__ELL} />{' '}
          <Translation
            {...TXTWCL_Read_more_about_play_money_and_ELL}
            values={{
              a: (msg: string) => (
                <Link
                  onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    onEulaLinkClick?.();
                  }}
                  href={MCEula}
                >
                  {msg}
                </Link>
              )
            }}
          />
        </Alert>
      );
    default:
      return null;
  }
};

export default InfoBox;
